import { ChangeDetectorRef, Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Aporte } from "src/app/models/calculo_aporte.model";
import { formatNumber } from "@angular/common";
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-calculo-aporte',
  templateUrl: './calculo-aporte.component.html',
  styleUrls: ['./calculo-aporte.component.css'],
  providers: [FormService]
})
export class CalculoAporteComponent {

  public rows = [];
  public actualRow;
  public aporte: Aporte;
  public form;
  public totalUni;

  matcher = new FormService();

  constructor(public _formService: FormService, private fb: FormBuilder, private _changeDetectionRef: ChangeDetectorRef) {
      this.form = new FormGroup({
        avaluoVigente: new FormControl(0, Validators.pattern(/[0-9]*/)),
        porcentaje: new FormControl(0, Validators.pattern(/[0-9]*/)),
        avaluoIncremento: new FormControl(0, Validators.pattern(/[0-9]*/)),
        cesion: new FormControl(0, Validators.pattern(/[0-9]*/)),
        aporteEquivalente: new FormControl(0, Validators.pattern(/[0-9]*/)),
      
      })
      if (!JSON.parse(localStorage.getItem("aporte"))) {
          localStorage.setItem("aporte", JSON.stringify(this.rows));
      } else {
          this.rows = JSON.parse(localStorage.getItem("aporte"));

          this.form.controls['avaluoVigente'].setValue(this.rows[0] ?  formatNumber(Math.round(this.rows[0].avaluoVigente), 'cl') : 0)
          this.form.controls['avaluoIncremento'].setValue(this.rows[0] ? formatNumber(Math.round(this.rows[0].avaluoIncremento), 'cl') : 0)
          this.form.controls['aporteEquivalente'].setValue(this.rows[0] ? formatNumber(Math.round(this.rows[0].aporteEquivalente), 'cl') : 0)
          this.form.controls['cesion'].setValue(this.rows[0] ? this.rows[0].cesion : 0)
          this.form.controls['porcentaje'].setValue(this.rows[0] ? this.rows[0].porcentaje : 0)
      
      }
      this.aporte = { 
        avaluoVigente: 0, 
        porcentaje: 0, 
        avaluoIncremento: 0, 
        cesion: 0, 
        aporteEquivalente: 0
      };

  }

  add_aporte() {



      localStorage.setItem("aporte", JSON.stringify([]));
      this.actualRow = localStorage.getItem("aporte");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        avaluoVigente:  formatNumber(Math.round(this.form.value.avaluoVigente), 'cl'),
        avaluoIncremento: formatNumber(Math.round(this.form.value.avaluoIncremento), 'cl'),
        aporteEquivalente: formatNumber(Math.round(this.form.value.aporteEquivalente), 'cl'),
        cesion: this.form.value.cesion,
        porcentaje: this.form.value.porcentaje,
      })
      localStorage.setItem("aporte", JSON.stringify(this.rows));
  }

  delete_unidades(id) {
      for (let x = 0; x < this.rows.length; x++) {
          if (id == x) {
              this.rows.splice(x, 1);
              localStorage.setItem("aporte", JSON.stringify(this.rows));
          }
      }
  }




}
